export default {
  name: 'usurp-header',
  path: 'M0,0 H1 V0.823 C1,0.823,0.695,1,0.499,1 C0.303,1,0,0.823,0,0.823 V0',
};
